import React from "react";
import SESTree from "../../../assets/images/SES_TreeRevised1.png";
import Layout from "../../Layout";
import HeaderWelcome from "./HeaderWelcome";

const Welcome = () => (
  <Layout>
    <HeaderWelcome />
    <section className="layout-container">
      <div className="container">
        <div className="left-panel-s1">
          <div className="form-title g-clr">Welcome to Direct!</div>
          <section className="text-size6">
            <p>
              You currently do not have Direct email account to access with our
              Webmail system. Using our secure messaging system will allow you
              to receive admit and discharge notifications, submit information
              to plans to expedite payment, exchange referrals, pre-op notes,
              immunization records, patient histories, and many more.
            </p>
            <p>
              To begin using Direct, please contact your administrator to help
              get your account set up with a Direct email address.
            </p>
          </section>
        </div>
        <div className="right-panel-s1">
          <aside>
            <img
              src={SESTree}
              className="w-full"
              alt="Healthcare Assorted Icons In A Tree"
            />
          </aside>
        </div>
      </div>
    </section>
  </Layout>
);

Welcome.defaultProps = {};

export default Welcome;
